import { useTranslate } from "react-admin";
import { useLocation } from "react-router-dom";

// These pages show their own page header.
const PAGES_WITH_OWN_HEADER = ["crm", "marketing", "organizations", "access-denied", "authentication-error"];

// Returns the resource name from the URL if the path is like /Resource (e.g., /Organization),
// otherwise returns null. Does NOT return the entity name for /Resource/id or /Resource/id/show.
export const useGetEntityName = (): string | null => {
  const location = useLocation();
  const translate = useTranslate();
  const pathnames = location.pathname.split("/").filter(Boolean);

  if (pathnames.length === 1 && !PAGES_WITH_OWN_HEADER.includes(pathnames[0]))
    return translate(`resources.${pathnames[0]}`);
  return null;
};
